import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './LargeButton.module.scss';
import {ReactComponent as Arrow} from '../../assets/arrow.svg';
import { Link } from './Link';
import KTween from '../../core/KTween';

interface LargeButtonProps
{
	caption?:string,
	label?:string,
	description?:string,
	tags?:any[],
	tagColumn?:boolean,
}

export class LargeButton extends React.Component<LargeButtonProps>
{

	private _border:HTMLElement;

	
	private _mouseOver = (e) =>
	{
		KTween.remove(this._border);
		this._border['_pos'] = e.nativeEvent.layerX;
		this._border['_over'] = 0;
		KTween.tween(this._border, {_over: 1, onUpdate: this._updateBorder}, 'easeInOutQuart', 0.3);
	}

	private _mouseOut = (e) =>
	{
		KTween.remove(this._border);
		this._border['_pos'] = e.nativeEvent.layerX;
		this._border['_over'] = 0;
		KTween.tween(this._border, {_over: 0, onUpdate: this._updateBorder}, 'easeInOutQuart', 0.1);
	}

	private _updateBorder = () =>
	{
		let p = this._border['_over'];
		let pos = this._border['_pos'];
		let b = this._border.parentElement.getBoundingClientRect();
		this._border.style['left'] = pos * (1 - p) + 'px';
		this._border.style['width'] = ((b.width - pos * (1 - p)) * p) + 'px';
	}

	private _buildCaptionTags(tags)
	{
		if(!tags) return;
		let tagElements = [];
		for(let t of tags)
		{
			let tag;
			switch(t)
			{
				case 'onsite':
					tag = {
						label: 'On-site',
						className: t,
					}
					break;
					case 'online':
					tag = {
						label: 'Online',
						className: t,
					}
					break;
					case 'for-students':
					tag = {
						label: 'for students',
						className: t,
					}
					break;
				}
			if(tag)
			{
				tagElements.push(tag);
			}
		}
		if(tagElements.length > 0)
		{
			return (
				<ul className={mergeClassNames(['caption-tags'], styles)}>
					{tagElements.map((t, i) => (<li key={i} className={mergeClassNames([t['className']], styles)}>{t['label']}</li>))}
				</ul>
			);
		}
		return null;
	}

	render()
	{
		return (
			<Link onMouseEnter={this._mouseOver} onMouseLeave={this._mouseOut} arrow={false} {...this.props} className={mergeClassNames([this.props['className'], 'button'], styles)}>
				{
					(this.props['caption'] || (this.props['caption-description']) || (this.props['caption-tags']))?(
						<div className={mergeClassNames(['caption'], styles)}>
							{this.props['caption']?(<div className={mergeClassNames(['caption-text'], styles)}>{this.props['caption']}</div>):null}
							{
								this._buildCaptionTags(this.props['caption-tags'])
							}
							{
								(this.props['caption-description'])?(
									<span className={mergeClassNames(['caption-description'], styles)}>{this.props['caption-description']}</span>
								):null
							}
						</div>
					):null
				}
				<div className={mergeClassNames(['field'], styles)}>
					{this.props['label']?ContentBuilder.build({
						tag: 'div',
						props: {className: 'label'},
						content: this.props['label']
					}, {}, styles):null}
					<Arrow className={mergeClassNames(['arrow'], styles)}></Arrow>
				</div>
				{this.props['description']?ContentBuilder.build({
					tag: 'div',
					props: {className: 'description'},
					content: this.props['description']
				}, {}, styles):null}

				{
					this.props['tags'] && this.props['tags'].length > 0?ContentBuilder.build(
						{
							tag: 'div',
							props: {className: mergeClassNames([styles['tags'], (this.props['tagColumn'])?styles['column']:null])},
							content: this.props['tags']
						}, {}, styles
					):null
				}

				<div ref={r => this._border = r} className={mergeClassNames('border', styles)}></div>

			</Link>
		);
	}
}